module.exports = "/_next/static/images/warranty-promo-vert-3ff44cd3cf6271726fcd9e5a4ceed84d.png";